import { AsyncLoaderTemplate } from '@shared/Frontend/asyncLoader'
import { fieldReplacer } from '@shared/Frontend/utils/updaters'
import { AsyncState, Maybe, Template, unit, Unit } from 'ballerina-core'
import React, { ReactNode } from 'react'
import { getSiteBanner } from './siteBanner.api'
import { SiteBanner, SiteBannerState } from './siteBanner.state'

export type SiteBannerView = {
  SiteBanner: (_: { content: string; close: () => void }) => ReactNode
}

export const SiteBannerTemplate = Template.Default<Unit, SiteBannerState, Unit, SiteBannerView>(
  ({ context, setState, view }) => (
    <>
      <SiteBannerLoaderTemplate
        context={{ ...context, promise: getSiteBanner }}
        setState={setState}
        foreignMutations={unit}
        view={unit}
      />

      {AsyncState.Operations.hasValue(context) && context.value && (
        <view.SiteBanner
          content={context.value.content}
          close={(): void =>
            setState(AsyncState.Operations.map(Maybe.Operations.map(fieldReplacer<SiteBanner>()('closed')(true))))
          }
        />
      )}
    </>
  )
)

const SiteBannerLoaderTemplate = AsyncLoaderTemplate<Maybe<SiteBanner>>()
